/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Faq_A2Inputs */

const en_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each person can only enter one invite code.`)
};

const ar_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكن لكل شخص إدخال رمز دعوة واحد فقط.`)
};

const de_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Person kann nur einen Einladungscode eingeben.`)
};

const es_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada persona solo puede introducir un código de invitación.`)
};

const fr_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque personne ne peut saisir qu’un seul code d’invitation.`)
};

const it_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni persona può inserire un solo codice invito.`)
};

const ja_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1人につき入力できる招待コードは1つだけです。`)
};

const ko_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 사람은 초대 코드를 하나만 입력할 수 있어요.`)
};

const pt_br_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada pessoa só pode inserir um código de convite.`)
};

const ru_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый человек может ввести только один код приглашения.`)
};

const th_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แต่ละคนกรอกรหัสเชิญได้เพียงหนึ่งรหัสเท่านั้น`)
};

const tr_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her kişi yalnızca bir davet kodu girebilir.`)
};

const zh_cn_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个人只能输入一组别人的邀请码。`)
};

const zh_tw_invite_page_faq_a2 = /** @type {(inputs: Invite_Page_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每個人只能輸入一組別人的邀請碼。`)
};

/**
* | output |
* | --- |
* | "Each person can only enter one invite code." |
*
* @param {Invite_Page_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_faq_a2 = /** @type {((inputs?: Invite_Page_Faq_A2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Faq_A2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_faq_a2(inputs)
	if (locale === "ar") return ar_invite_page_faq_a2(inputs)
	if (locale === "de") return de_invite_page_faq_a2(inputs)
	if (locale === "es") return es_invite_page_faq_a2(inputs)
	if (locale === "fr") return fr_invite_page_faq_a2(inputs)
	if (locale === "it") return it_invite_page_faq_a2(inputs)
	if (locale === "ja") return ja_invite_page_faq_a2(inputs)
	if (locale === "ko") return ko_invite_page_faq_a2(inputs)
	if (locale === "pt_br") return pt_br_invite_page_faq_a2(inputs)
	if (locale === "ru") return ru_invite_page_faq_a2(inputs)
	if (locale === "th") return th_invite_page_faq_a2(inputs)
	if (locale === "tr") return tr_invite_page_faq_a2(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_faq_a2(inputs)
	return zh_tw_invite_page_faq_a2(inputs)
});